'use strict';

/**
 * @ngdoc service
 * @name cloudBillingLegacyFrontend.eaBackendAdmin
 * @description
 * # eaBackendAzure
 * Service in the cloudBillingLegacyFrontend.
 */
angular.module('cloudBillingLegacyFrontend').service('$eaBackendAdminV2', function($q, $timeout, $http, $eaBackendBase, $eaConfig) {
  var self = this;

  // This is the main uri of the backend
  var adminUri    = ($eaConfig.getConfiguration().apiProtocol ? $eaConfig.getConfiguration().apiProtocol : 'https') + '://' + $eaConfig.getConfiguration().apiHostAdminV2 + '/api/v2/admin';

  self.dataGetJobs = function(hours, optionalTeam, dataToken) {

    var teamFilter = '';
    if (optionalTeam) { teamFilter = '&teamId=' + optionalTeam; }
    return $eaBackendBase.extractDataFromResponse($http.get(adminUri + '/jobs?hours=' + hours + teamFilter, {headers: $eaBackendBase.getDefaultHeaders(dataToken)}));
  };

  self.dataGetJobEntries = function(partitionKey, dataToken) {
    return $eaBackendBase.extractDataFromResponse($http.get(adminUri + '/jobs/' + partitionKey + '/entries', {headers: $eaBackendBase.getDefaultHeaders(dataToken)}));
  };

  self.dataBookPlan = function(profileId, planId, serviceProviderId, dataToken) {
    return $eaBackendBase.extractDataFromResponse($http.post(adminUri + '/profile/billing', { userId: profileId, plan: planId, serviceProviderId: serviceProviderId}, {headers: $eaBackendBase.getDefaultHeaders(dataToken)}));
  };

});
